/** Shared team group ordering and labels for all report catalogs. */
export const REPORT_GROUP_ORDER = ["ops", "sales", "accounting", "others"];

export const REPORT_GROUP_LABELS = {
    ops: "Ops Reports",
    sales: "Sales Reports",
    accounting: "Accounting Reports",
    others: "Others",
};

/**
 * @param {Array<object>} catalog
 * @param {string} mode
 */
export function getReportsForMode(catalog, mode) {
    if (!Array.isArray(catalog)) return [];
    return catalog.filter((r) => r.modes?.includes(mode));
}

/**
 * @param {Array<object>} catalog
 * @param {string} mode
 */
export function getGroupedReports(catalog, mode) {
    const reports = getReportsForMode(catalog, mode);
    /** @type {Record<string, typeof reports>} */
    const grouped = {};
    REPORT_GROUP_ORDER.forEach((g) => {
        grouped[g] = [];
    });
    reports.forEach((r) => {
        const key = r.group && grouped[r.group] ? r.group : "others";
        grouped[key].push(r);
    });
    return grouped;
}

/**
 * @param {object} report
 * @param {{ mode: string, resolveLegacyHref?: (mode: string, legacyPage: string) => string | null }} context
 */
export function resolveReportHref(report, { mode, resolveLegacyHref }) {
    if (!report) return { href: "#", external: false };
    if (report.linkType === "route" && report.path) {
        return { href: report.path, external: false };
    }
    if (report.linkType === "external" && report.url) {
        return { href: report.url, external: true };
    }
    if (report.linkType === "legacy" && report.legacyPage && resolveLegacyHref) {
        const href = resolveLegacyHref(mode, report.legacyPage);
        if (href) return { href, external: true };
    }
    return { href: "#", external: false };
}
